import { StepDataType } from "../dtos";

export const emptyGuid = '00000000-0000-0000-0000-000000000000';

export const StepDataTypeToName = new Map<StepDataType, string>([
    [StepDataType.DATE, 'Date'],
    [StepDataType.FILE, 'File'],
    [StepDataType.TEXT, 'Text'],
    [StepDataType.BOOLEAN, 'True/False'],
])